WL.registerComponent('body-slots-assign', {
  hat: { type: WL.Type.String },
  head: { type: WL.Type.String },
  mouth: { type: WL.Type.String },
  eyes: { type: WL.Type.String },
  body: { type: WL.Type.String },
}, {
  init: function() {
    this.bodySlots = this.object.getComponent('body-slots');
  },
  start: function() {
    this.bodySlots.setHead(this.head);
    this.bodySlots.setHat(this.hat);
    this.bodySlots.setMouth(this.mouth);
    this.bodySlots.setEyes(this.eyes);
    this.bodySlots.setBody(this.body);
  }
});